import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import {
  AttendeeIcon,
  BellIcon,
  CalendarIcon,
  CallVideoIcon,
  CheckmarkCircleIcon,
  ContactGroupIcon,
  ContentIcon,
  MenuIcon,
  PollIcon,
  SettingsIcon,
  StarIcon,
  WhiteboardIcon,
  ShareGenericIcon,
  ChatIcon,
  ScreenshareIcon,
  RobotIcon,
  CallIcon,
  GridIcon,
} from "@fluentui/react-icons-northstar";

import {
  Button,
  Divider,
  Flex,
  Image,
  Layout,
  Segment,
  Tooltip,
} from "@fluentui/react-northstar";
import {
  default as Logo,
  default as LogoLight,
} from "../../Assets/images/logo.png";

import * as Icon from "react-feather";

import "./Header.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  FullscreenOutlined,
  FullscreenExitOutlined,
  SlackCircleFilled,
  GroupOutlined,
} from "@ant-design/icons";
import AiDropdownMenu from "./AiDropdownMenu";
import { Badge } from "antd";
import { useNotification } from "../../context/NotificationContext";
import { useTrustedNetwork } from "../../context/TrustedNetworkContext";
import NotificationPopup from "../Common/NotificationPopup";
import { useAiRoutes } from "../../App/useAiRoutes";

const Navbar = (props_) => {
  const {
    props,
    setHam,
    ham,
    isMobileView,
    openModal,
    profileButton,
    t,
    openFullscreen,
    closeFullscreen,
    isFullscreen,
  } = props_;

  const { isTrusted, isInitialLoading } = useTrustedNetwork();

  const { extensionInfo, aiRoutes } = useAiRoutes(props.selectedExtension);
  const [showIconsOnly, setShowIconsOnly] = useState(false);
  const navRef = useRef(null);
  const [availableWidth, setAvailableWidth] = useState(0);

  const getColor = (selectedTab) => {
    return props.selectedTab === selectedTab ? "#68689E" : "#544F53";
  };

  const history = useHistory();

  const handleNavigation = (path) => {
    return history.push(path);
  };

  const isActive = (selectedTab) => {
    let baseClass =
      props.selectedTab === selectedTab ? "activeBtn activeTab" : "button";

    return baseClass;
  };
  const subscription = JSON.parse(localStorage.getItem("subscription"));
  const tabsWithFilter = [
    "whiteboard",
    "assignments",
    "tutors",
    "attendance",
    "feedback",
    "events",
  ];

  const toggleClass = (element, classToRemove, classToAdd) => {
    if (element) {
      element.classList.add(classToAdd);
      element.classList.remove(classToRemove);
    }
  };

  const { unreadCount } = useNotification();

  // Responsive navigation handling
  useEffect(() => {
    const handleResize = () => {
      if (navRef.current) {
        const navWidth = navRef.current.offsetWidth;
        const rightNavWidth =
          document.querySelector(".rightNav")?.offsetWidth || 200;
        const logoWidth = window.innerWidth < 930 ? 70 : 166;
        const availableNavWidth =
          window.innerWidth - logoWidth - rightNavWidth - 100; // 100px buffer

        setAvailableWidth(availableNavWidth);
        // Show icons only when available width is less than 800px (approximate width needed for all nav items)
        setShowIconsOnly(availableNavWidth < 800 && window.innerWidth > 790);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Navigation items configuration with icons
  const getNavItems = () => {
    const items = [];

    if (props?.user?.role.toLowerCase() === "parent") {
      items.push({
        key: "student",
        path: "/parent/student",
        label: "Student",
        icon: <ContactGroupIcon outline size="large" />,
        show: true,
      });
    }

    if (
      ["Admin", "SuperAdmin", "Teacher"].includes(props.user?.role) &&
      props.selectedExtension?.attendance
    ) {
      items.push({
        key: "attendance",
        "data-cy": "attendance-page-navigator",
        path: "/attendance",
        label: "Attendance",
        icon: <ContactGroupIcon outline size="large" />,
        show: true,
      });
    }

    if (
      props.selectedExtension?.assignment &&
      !["parent", "externaltutor"].includes(props.user?.role.toLowerCase())
    ) {
      items.push({
        key: "assignments",
        path: "/assignments",
        label: "Assignments",
        "data-cy": "assignments-page-navigator",
        icon: <ShareGenericIcon outline size="large" />,
        show: true,
      });
    }

    if (
      props.user &&
      ["Admin", "SuperAdmin", "Teacher", "Student"].includes(
        props.user?.role
      ) &&
      props.selectedExtension?.dashboard
    ) {
      items.push({
        key: "dashboard",
        path: "/dashboard",
        label: "Dashboard",
        icon: <PollIcon outline size="large" />,
        show: true,
      });
    }

    if (
      props.user &&
      ["Admin", "SuperAdmin", "Teacher", "Student"].includes(
        props.user?.role
      ) &&
      props.selectedExtension?.whiteBoard
    ) {
      items.push({
        key: "whiteboard",
        path: "/whiteboard",
        label: "Whiteboard",
        icon: (
          <WhiteboardIcon outline size="large" className="whiteboard-icon" />
        ),
        show: true,
      });
    }

    if (
      props.user &&
      ["Admin", "SuperAdmin", "Teacher", "Student", "Parent"].includes(
        props.user?.role
      ) &&
      props.selectedExtension?.events
    ) {
      items.push({
        key: "events",
        path:
          props.user.role === "Parent"
            ? "/events/discover"
            : "/events/my-events",
        label: "Events",
        icon: <CalendarIcon outline size="large" />,
        "data-cy": "events-page-navigator",
        show: true,
      });
    }

    if (
      (!["admin", "superadmin", "parent"].includes(
        props?.user?.role.toLowerCase()
      ) ||
        props?.user?.isTutor) &&
      props.selectedExtension?.booking
    ) {
      items.push({
        key: "booking",
        path: "/booking",
        label: "Booking",
        icon: <CallIcon outline size="large" />,
        show: true,
        "data-cy": "booking-page-navigator",
      });
    }

    if (
      !["externaltutor"].includes(props?.user?.role.toLowerCase()) &&
      props.selectedExtension?.feedback
    ) {
      items.push({
        key: "feedback",
        path: "/feedback/submit-feedback",
        label: "Feedback",
        "data-cy": "feedback-page-navigator",
        icon: <ChatIcon outline size="large" />,
        show: true,
      });
    }

    if (
      props?.selectedExtension?.whiteBoard &&
      props.user &&
      ["Admin", "SuperAdmin"].includes(props.user?.role) &&
      !isInitialLoading && // Wait for initial data to load
      isTrusted // Only show if trusted everyone is enabled
    ) {
      items.push({
        key: "trusted-network",
        path: "/trusted-network",
        label: "Trusted Network",
        icon: <ScreenshareIcon outline size="large" />,
        show: true,
      });
    }

    // Exam Dashboard extension - visible for all roles if enabled in extensions or by default
    if (
      props?.selectedExtension?.examDashboard &&
      props.user &&
      ["Admin", "SuperAdmin", "Teacher", "Student"].includes(props.user?.role)
    ) {
      items.push({
        key: "examDashboard",
        path: "/examDashboard",
        label: "Exam Dashboard",
        "data-cy": "exam-dashboard-page-navigator",
        icon: <GridIcon outline size="large" />,
        show: true,
      });
    }

    if (props.user && ["Admin", "SuperAdmin"].includes(props.user?.role)) {
      items.push({
        key: "settings",
        path: "/settings",
        "data-cy": "settings-page-navigator",
        label: "Settings",
        icon: <SettingsIcon outline size="large" />,
        show: true,
      });
    }

    // Add Skill Bridge nav item for Student or Teacher
    if (
      props?.selectedExtension?.skillBridge &&
      props.user &&
      ["Teacher", "Student"].includes(props.user?.role)
    ) {
      items.push({
        key: "skillBridge",
        path: "/skillBridge",
        label: "SkillBridge",
        icon: <StarIcon outline size="large" />,
        show: true,
      });
    }

    return items.filter((item) => item.show);
  };

  const renderNavItem = (item) => {
    if (showIconsOnly) {
      return (
        <Tooltip
          key={item.key}
          content={item.label}
          trigger={
            <Link
              to={item.path}
              onClick={() => props.setSelectedTab(item.key)}
              className={isActive(item.key)}
              {...(item["data-cy"] && { "data-cy": item["data-cy"] })}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "40px",
                height: "32px",
              }}
            >
              {item.icon}
            </Link>
          }
        />
      );
    }

    return (
      <Link
        key={item.key}
        to={item.path}
        onClick={() => props.setSelectedTab(item.key)}
        className={isActive(item.key)}
        {...(item["data-cy"] && { "data-cy": item["data-cy"] })}
      >
        {item.label}
      </Link>
    );
  };

  const notificationTrigger = (
    <Button
      id="notification-bell"
      icon={
        <Badge count={unreadCount} size="small">
          <BellIcon outline />
        </Badge>
      }
      iconOnly
      text
    />
  );

  // Helper to check if user is Teacher, Student, Ministry, or Partner
  const isSkillBridgeRole = [
    "teacher",
    "educator",
    "student",
    "ministry",
    "partner",
  ].includes(props?.user?.role?.toLowerCase());
  const isPartnerOrMinistry = ["partner", "ministry"].includes(
    props?.user?.role?.toLowerCase()
  );
  const isStudentOrTeacher = ["student", "teacher"].includes(
    props?.user?.role?.toLowerCase()
  );

  return (
    <Flex
      gap="gap.small"
      style={{ height: "60px", backgroundColor: "#F3F2F1" }}
    >
      <Link
        to={
          props.selectedExtension?.attendance &&
          !isPartnerOrMinistry &&
          "/attendance"
        }
        data-cy="attendance-page-navigator"
        onClick={() => {
          props.setSelectedTab("attendance");
        }}
        style={{
          width: window.innerWidth < 930 ? "70px" : "166px",
        }}
      >
        <Image
          className="link-image"
          src={
            props.user?.dbData?.db_selected === "Trial" &&
            props.user?.role === "Admin"
              ? props.user?.mode === "dark"
                ? LogoLight
                : Logo
              : props.user?.schoolInfo?.SchoolLogo
              ? props.user?.schoolInfo?.SchoolLogo + props.user?.SASToken
              : props.user?.mode === "dark"
              ? LogoLight
              : Logo
          }
          title={props.user?.schoolInfo?.School || "Tangible IT"}
        />
      </Link>
      <>
        <Flex
          gap="gap.medium"
          style={{ paddingBlock: "20px" }}
          className="ctr-right"
        >
          {props.user?.role === "Admin" && (
            <Flex.Item>
              <Button
                icon={<ContentIcon outline size="large" />}
                content={t("startUp").initial[1]}
                className="startUp-btn"
              />
            </Flex.Item>
          )}
          {isMobileView && props.selectedReportPath && (
            <Icon.Filter
              size="20"
              className="ctrl"
              onClick={() => {
                openModal();
              }}
            />
          )}
          <MenuIcon
            outline
            size="large"
            className="Ham ctrl"
            onClick={() => setHam(!ham)}
          />
        </Flex>

        <div className={ham ? "ham_container active" : "ham_container"}>
          <div className="cover">
            <Flex column>
              {/* Hamburger: Only show SkillBridge for partner/ministry */}
              {isPartnerOrMinistry ? (
                <Segment
                  content={
                    <Layout
                      gap="1rem"
                      vertical={false}
                      start={<StarIcon outline size="large" />}
                      main="Skill Bridge"
                      end=""
                      style={{ color: getColor("skillBridge") }}
                      onClick={() => {
                        handleNavigation("/skillBridge");
                        setHam(!ham);
                      }}
                    />
                  }
                />
              ) : (
                <>
                  {props.user &&
                    ["Admin", "SuperAdmin", "Teacher"].includes(
                      props.user?.role
                    ) && (
                      <Segment
                        content={
                          <Layout
                            data-cy="attendance-page-navigator"
                            gap="1rem"
                            vertical={false}
                            start={<ContactGroupIcon outline size="large" />}
                            main="Attendance"
                            end=""
                            style={{
                              color: getColor("attendance"),
                            }}
                            onClick={() => {
                              handleNavigation("/attendance");
                              setHam(!ham);
                            }}
                          />
                        }
                      />
                    )}
                  <Segment
                    content={
                      <Layout
                        gap="1rem"
                        vertical={false}
                        start={<ShareGenericIcon outline size="large" />}
                        main="Assignments"
                        end=""
                        data-cy="assignments-page-navigator"
                        style={{
                          color: getColor("assignments"),
                        }}
                        onClick={() => {
                          handleNavigation("/assignments");
                          setHam(!ham);
                        }}
                      />
                    }
                  />

                  {props.user &&
                    ["Admin", "SuperAdmin", "Teacher", "Student"].includes(
                      props.user?.role
                    ) && (
                      <Segment
                        content={
                          <Layout
                            gap="1rem"
                            vertical={false}
                            start={<PollIcon outline size="large" />}
                            main="Dashboard"
                            end=""
                            style={{
                              color: getColor("dashboard"),
                            }}
                            onClick={() => {
                              handleNavigation("/dashboard");
                              setHam(!ham);
                            }}
                          />
                        }
                      />
                    )}
                  {props.user &&
                    ["Admin", "SuperAdmin", "Teacher", "Student"].includes(
                      props.user?.role
                    ) && (
                      <Segment
                        content={
                          <Layout
                            gap="1rem"
                            vertical={false}
                            start={<WhiteboardIcon outline size="large" />}
                            main="Whiteboard"
                            end=""
                            style={{
                              color: getColor("whiteboard"),
                            }}
                            onClick={() => {
                              handleNavigation("/whiteboard");
                              setHam(!ham);
                            }}
                          />
                        }
                      />
                    )}
                  <Segment
                    content={
                      <Layout
                        gap="1rem"
                        vertical={false}
                        start={<CalendarIcon outline size="large" />}
                        main="Events"
                        end=""
                        style={{
                          color: getColor("events"),
                        }}
                        onClick={() => {
                          handleNavigation("/events/my-events");
                          setHam(!ham);
                        }}
                      />
                    }
                  />
                  {!["admin", "superadmin", "parent"].includes(
                    props?.user?.role.toLowerCase()
                  ) ? (
                    <Segment
                      content={
                        <Layout
                          gap="1rem"
                          vertical={false}
                          start={<CallIcon outline size="large" />}
                          main="Booking"
                          end=""
                          style={{
                            color: getColor("booking"),
                          }}
                          onClick={() => {
                            handleNavigation("/booking");
                          }}
                        />
                      }
                    />
                  ) : null}
                  {!isPartnerOrMinistry &&
                    props.user &&
                    ["Admin", "SuperAdmin", "Teacher"].includes(
                      props.user?.role
                    ) && (
                      <Segment
                        content={
                          <Layout
                            gap="1rem"
                            vertical={false}
                            start={<CheckmarkCircleIcon outline size="large" />}
                            main={"Attendance History"}
                            end=""
                            style={{
                              color: getColor("history"),
                            }}
                            onClick={() => {
                              handleNavigation("/history");
                              setHam(!ham);
                            }}
                          />
                        }
                      />
                    )}
                  <Segment
                    content={
                      <Layout
                        gap="1rem"
                        vertical={false}
                        start={<ChatIcon outline size="large" />}
                        main="Feedback"
                        end=""
                        style={{
                          color: getColor("feedback"),
                        }}
                        onClick={() => {
                          handleNavigation("/feedback/submit-feedback");
                          setHam(!ham);
                        }}
                      />
                    }
                  />
                  {props.user &&
                    ["Admin", "SuperAdmin"].includes(props.user?.role) && (
                      <Segment
                        content={
                          <Layout
                            gap="1rem"
                            vertical={false}
                            start={<SettingsIcon outline size="large" />}
                            main="Settings"
                            end=""
                            style={{
                              color: getColor("settings"),
                            }}
                            onClick={() => {
                              handleNavigation("/settings");
                              setHam(!ham);
                            }}
                          />
                        }
                      />
                    )}

                  {/* Dynamic AI Routes in Mobile Menu */}
                  {aiRoutes &&
                    aiRoutes.length > 0 &&
                    aiRoutes.map((route) => (
                      <Segment
                        key={route.path}
                        content={
                          <Layout
                            gap="1rem"
                            vertical={false}
                            start={
                              <Image
                                src={route.image}
                                alt={route.name}
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "4px",
                                  backgroundColor: "rgb(110 105 108)",
                                  objectFit: "contain",
                                }}
                              />
                            }
                            main={route.name}
                            end=""
                            style={{
                              color: getColor(route.path),
                            }}
                            onClick={() => {
                              handleNavigation(`/${route.path}`);
                              setHam(!ham);
                            }}
                          />
                        }
                      />
                    ))}
                  <Divider className="ham-dv" />
                  <Segment
                    content={
                      <Layout
                        gap="0rem"
                        vertical={false}
                        main={profileButton}
                        style={{ color: "#544F53" }}
                      />
                    }
                  />
                </>
              )}
            </Flex>
          </div>
        </div>

        <nav style={{ paddingTop: "17px", display: "flex" }}>
          {isPartnerOrMinistry ? (
            <Link
              to="/skillBridge"
              onClick={() => {
                props.setSelectedTab("skillBridge");
              }}
              className={isActive("skillBridge")}
            >
              Skill Bridge
            </Link>
          ) : (
            <>
              <nav
                ref={navRef}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  overflow: "hidden",
                }}
              >
                {/* Render navigation items */}
                {getNavItems().map(renderNavItem)}

                {/* Dynamic AI Dropdown - responsive like other nav items */}
                <AiDropdownMenu
                  selectedExtension={props.selectedExtension}
                  user={props.user}
                  setSelectedTab={props.setSelectedTab}
                  isActive={isActive}
                  selectedTab={props.selectedTab}
                  showIconsOnly={showIconsOnly}
                />

                {!props.openWorkSpace &&
                  tabsWithFilter.includes(props.selectedTab) && (
                    <Icon.Filter
                      size="20"
                      className="ctrl"
                      style={{
                        marginTop: "-9px",
                      }}
                      onClick={() => {
                        const hiddenElement = document.querySelector(".h-ctr");
                        const shownElement = document.querySelector(".s-ctr");

                        if (hiddenElement) {
                          toggleClass(hiddenElement, "h-ctr", "s-ctr");
                        } else if (shownElement) {
                          toggleClass(shownElement, "s-ctr", "h-ctr");
                        }
                      }}
                    />
                  )}

                <Button
                  text
                  circular
                  icon={
                    isFullscreen ? (
                      <FullscreenExitOutlined />
                    ) : (
                      <FullscreenOutlined />
                    )
                  }
                  onClick={isFullscreen ? closeFullscreen : openFullscreen}
                  style={{
                    marginTop: "-7px",
                    minWidth: "2rem",
                    display: "block",
                  }}
                />
              </nav>
            </>
          )}
        </nav>

        <Flex
          className="rightNav"
          gap="gap.medium"
          hAlign="end"
          vAlign="center"
        >
          {/* Hide notifications from Teachers and Students - same pattern as Settings and Trusted Network */}
          {props.user && ["Admin", "SuperAdmin"].includes(props.user?.role) && (
            <NotificationPopup trigger={notificationTrigger} />
          )}
          {props.user?.role === "Admin" && (
            <Button
              icon={<ContentIcon outline size="large" />}
              content={window.innerWidth > 1100 ? t("startUp").initial[1] : ""}
              className="contentIcon"
              iconOnly={window.innerWidth < 1100}
            />
          )}
          {/* Hide Attendance History in rightNav for partner/ministry */}
          {!isPartnerOrMinistry &&
            ["attendance", "history"].includes(props.selectedTab) && (
              <Link
                to="/history"
                onClick={() => {
                  props.setSelectedTab("history");
                }}
                className={isActive("history")}
                style={{ marginLeft: 0 }}
              >
                <AttendeeIcon
                  style={{
                    marginRight: window.innerWidth > 1100 ? "8px" : "0",
                  }}
                />
                {window.innerWidth > 1100 ? "Attendance History" : ""}
              </Link>
            )}
          {profileButton}
        </Flex>
      </>
    </Flex>
  );
};

export default Navbar;
